<template>
  <section class="partners">
    <div class="default-container">
      <ul>
        <li class="enea"><img src="/partners/enea-italian-national-agency-for-new-technologies-energy-and-sustainable-economic-development.svg" width="202" alt="enea"></li>
        <li class="fbk"><img src="/partners/fondazione-bruno-kessler-fbk.svg" width="91" alt="fondazione bruno kessler"></li>
        <!--<li class="trento"><img src="/partners/trento.svg" width="230" alt="università di trento"></li>-->
        <!--<li class="padova"><img src="/partners/padova.svg" width="171" alt="università di padova"></li>-->
        <li class="protos"><img src="/partners/protos-group-logo@2x.png" width="190" height="52px" alt="protos group"></li>
      </ul>
    </div>
  </section>
</template>

<script>

export default {
  props: {
    lang: {
      type: String,
      required: true
    }
  }
}

</script>

<style lang="scss">
  @import "../assets/mixins/breakpoints";
  @import "../assets/mixins/typo";

.partners{
  padding: 40px 0;
  border-top: 1px solid #343434;
  @media #{$medium_mq} {
    padding: 50px 0;
  }
  @media #{$large_mq} {
    padding: 60px 0;
  }
  @media #{$xlarge_mq} {
    padding: 70px 0;
  }
  @media #{$xxlarge_mq} {
    padding: 80px 0;
  }
  ul {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    align-items: center;
    li {
      margin: 20px;
@media #{$small_mq} {
  margin: 0;
  padding: 30px 20px;
     width: 100%;
    text-align: center;
    border-bottom: 1px solid #D8D8D8;
    &:last-child {
border-bottom: none;
  }
  }
    }
    li img{
      height: auto;
    }
    .enea img{
      width: 162px;
    }
    .fbk img{
      width: 73px;
    }
    .trento img{
      width: 184px;
    }
    .padova img{
      width: 136px;
    }
    .protos img{
      width: 152px;
      height: 41px;
    }

    @media #{$large_mq} {
      flex-wrap: nowrap;
      /*justify-content: space-between;*/
      justify-content: space-evenly;
      li {
        margin: 0;
      }
      .enea img{
        width: 138px;
      }
      .fbk img{
        width: 61px;
      }
      .trento img{
        width: 156px;
      }
      .padova img{
        width: 115px;
      }
      .protos img{
        width: 129px;
        height: 35px;
      }
    }
    @media #{$xlarge_mq} {
      .enea img{
        width: 162px;
      }
      .fbk img{
        width: 73px;
      }
      .trento img{
        width: 184px;
      }
      .padova img{
        width: 136px;
      }
      .protos img{
        width: 152px;
        height: 41px;
      }
    }
    @media #{$xxlarge_mq} {
      .enea img{
        width: 202px;
      }
      .fbk img{
        width: 91px;
      }
      .trento img{
        width: 230px;
      }
      .padova img{
        width: 171px;
      }
      .protos img{
        width: 190px;
        height: 52px;
      }
    }
  }
}
</style>
